<script>
    export default {
        name: "ReedMore",
        props: {
            text: {
                type: String,
                default: ''
            },
            max: {
                type: Number,
                default: 200
            }
        },
        
        data() {
            return {
                expanded: false
            };
        },
        
        computed: {
            textIsLong() {
                return this.text.length > this.max;
            },
            computedText() {
                if (this.textIsLong) {
                    return this.expanded ? this.text : `${this.text.slice(0, this.max).trim()}...`;
                } else {
                    return this.text;
                }
            },
            buttonText() {
                return this.expanded ? 'Read less' : 'Read more';
            }
        }
    }
</script>

<template>
    <span class="read-more-container">
        {{ computedText }}
        <span v-if="textIsLong" @click.stop="expanded = !expanded"
              class="text-muted clickable text-muted">{{ buttonText }}</span>
    </span>
</template>

<style scoped>
    .read-more-container {
        white-space: pre-wrap;
    }
    .clickable {
        cursor: pointer;
        text-decoration: underline;
    }
</style>